export default __webpack_public_path__ + "static/media/washingtonfranca.c82c847b.jpg";